module.exports = __webpack_public_path__ + "static/media/logo.d094b739.png";